import { ChangeDetectionStrategy, Component } from '@angular/core'
import { FeatureFlagDirective } from '@directives/feature-flag.directive'

@Component({
  selector: 'albert-footer',
  imports: [
    FeatureFlagDirective
  ],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {

}
